<script>
import appConfig from '@/app.config'
import PageHeader from '@/components/page-header'
import Layout from '@/router/layouts/main'
import { Helper } from '@/mixin/helper'
import RestEditableTableV2 from '@/components/RestEditableTableV2'
import * as hostedZoneApi from '@/services/rest-api-sms/lib/hosted-zone/hosted-zone'
import { mapGetters } from 'vuex'

export default {
  page: {
    title: 'Manage Domain',
    meta: [{ name: 'description', content: appConfig.description }],
  },
  components: {
    Layout,
    PageHeader,
    RestEditableTableV2,
  },
  mixins: [Helper],
  data() {
    return {
      region: 'SG',
      isTableDataAvailable: true,
    }
  },
  computed: {
    ...mapGetters({
      hasAccess: 'identity/hasAccess',
    }),
    title() {
      return this.$t('domain.title')
    },
    fields() {
      return [
        {
          key: 'hosted_zone_id',
          label: 'Hosted Zone ID',
          placeholder: 'Enter Hosted Zone ID',
          editable: true,
          isSortable: false,
          validation: 'required|max:64,length|matches:/^[a-zA-Z0-9]+$/',
          thClass: 'mc-table--500',
        },
        {
          key: 'hosted_zone_name',
          label: 'Hosted Zone Name',
          placeholder: 'Enter Hosted Zone Name',
          editable: true,
          isSortable: false,
          validation: 'required|hostname',
          thClass: 'mc-table--500',
        },
        {
          key: 'value_route',
          label: 'Value Route',
          placeholder: 'Enter Value Route',
          editable: true,
          isSortable: false,
          validation: 'required|hostname',
          thClass: 'mc-table--500',
        },
      ]
    },
    apiClient() {
      return {
        get: hostedZoneApi.get,
        show: hostedZoneApi.show,
        store: hostedZoneApi.store,
        update: hostedZoneApi.update,
        delete: hostedZoneApi.deleteMany,
      }
    },
  },
  methods: {
    handleBack() {
      this.$router.back()
    },
    handleDataAvailable(isAvailable) {
      this.isTableDataAvailable = isAvailable
    },
    async handleChange() {
      const domainRef = this.$refs.domainRef.$refs
      await this.$nextTick()
      this.fields.forEach(field => {
        if (!field.editable) return
        domainRef[`${field.key}-ref`].$el.addEventListener('keydown', Helper.methods.preventTabKey)
      })
    },
  },
}
</script>

<template>
  <Layout>
    <PageHeader :title="title" />
    <div class="clearfix mc-btn-group__list">
      <div class="float-end">
        <b-button
          @click="handleBack"
          variant="outline-primary"
          menu-class="dropdown-menu-end"
          class="ms-3"
        >
          <i class="bx bx-arrow-back"></i> {{ $t('global.back') }}
        </b-button>
      </div>
    </div>
    <div class="card">
      <div class="card-body">
        <RestEditableTableV2
          ref="domainRef"
          v-show="isTableDataAvailable"
          searchable
          :fields="fields"
          :apiClient="apiClient"
          :bulkDeleteApi="true"
          :multiPayload="true"
          :enableAddButton="hasAccess([
            'sms-hosted-zone:create',
          ])"
          :enableDeleteButton="hasAccess([
            'sms-hosted-zone:delete',
          ])"
          @available-change="handleDataAvailable"
          trackBy="id"
          @changeData="handleChange"
        />
      </div>
    </div>
  </Layout>
</template>
